export const ActionTypes = {
    //event
    SET_EVENTS: 'SET_EVENTS',
    SET_EVENT: 'SET_EVENT',
    GET_ISSUES: 'GET_ISSUES',
    GET_ISSUES_MAP: 'GET_ISSUES_MAP',
    SAVE_EVENT: 'SAVE_EVENT',
    SAVE_EVENT_MAP: 'SAVE_EVENT_MAP',
    SAVE_NEW_EVENT: 'SAVE_NEW_EVENT',
    SAVE_NEW_EVENT_MAP: 'SAVE_NEW_EVENT_MAP',
    REMOVE_ISSUE_TO_MAP: 'REMOVE_ISSUE_TO_MAP',
    SET_PUSH_ISSUES: 'SET_PUSH_ISSUES',
    GET_TRACKERS_MAP: 'GET_TRACKERS_MAP',

    //user
    ADD_USER: 'ADD_USER',
    SELECT_USER: 'SELECT_USER',
    SELECT_USER_MAP: 'SELECT_USER_MAP',
    CREATE_USER: 'CREATE_USER',
    DELETE_USER: 'DELETE_USER',
    GET_USER_ID: 'GET_USER_ID',
    EDIT_USER: 'EDIT_USER',
    TECH_LOCATION: 'TECH_LOCATION',

    //projects
    SET_PROJECTS: 'SET_PROJECTS',
    SET_CURRENT_PROJECT: 'SET_CURRENT_PROJECT',

    //overview
    GET_OVERVIEW: 'GET_OVERVIEW',
    GET_OVERVIEW_BY_USER: 'GET_OVERVIEW_BY_USER',
    GET_OVERVIEW_BY_TRACKER: 'GET_OVERVIEW_BY_TRACKER',

    //notifications
    SET_NOTIS: 'SET_NOTIS',
    SET_NOTI_COUNT: 'SET_NOTI_COUNT',

    //auth
    LOGIN: 'LOGIN',
    GET_LOGIN: 'GET_LOGIN',
    GET_TOKEN: 'GET_TOKEN',
    REMOVE_TOKEN: 'REMOVE_TOKEN',

    //erorr
    ERROR_MSG: 'ERROR_MSG',
}


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js